import Typography from "@/ui/atoms/Typography";
import { Modal } from "@proda-ai/ui-kit";

type Change = {
    from: number;
    to: number;
};
export type ExtractionCompleteConfirmationModalProps = {
    showModal: boolean;
    changes?: [string, Change][];
    extractionsInfo:
        | {
              fileName: string;
              extractionId: number;
              sheetName: string;
          }[]
        | null;
    onConfirm: () => void;
    onCancel: () => void;
};

export const ExtractionCompleteConfirmationModal = ({
    showModal,
    changes,
    extractionsInfo,
    onConfirm,
    onCancel,
}: ExtractionCompleteConfirmationModalProps) => {
    const modalTitle = "Save extraction as completed";

    return (
        <Modal
            open={showModal}
            headerTitle={modalTitle}
            onCancel={onCancel}
            onClose={onCancel}
            onConfirm={onConfirm}
            textCancel="Cancel"
            textConfirm="Confirm"
        >
            <Typography variant="body3">
                By clicking confirm, you will be updating the source for the
                following:
                {changes?.map(([label, change]) => {
                    const from = extractionsInfo?.find(
                        info => info.extractionId === change.from,
                    );
                    const to = extractionsInfo?.find(
                        info => info.extractionId === change.to,
                    );
                    return (
                        <ul
                            style={{
                                listStyleType: "disc",
                                paddingLeft: "30px",
                            }}
                            key={`${label}-${change.from}-${change.to}`}
                        >
                            <li>
                                {label} will be updated
                                <ul
                                    style={{
                                        listStyleType: "circle",
                                        paddingLeft: "30px",
                                    }}
                                >
                                    <li>
                                        From: {from?.sheetName} Table{" "}
                                        {from?.extractionId} {">"}{" "}
                                        {from?.fileName}
                                    </li>
                                    <li>
                                        To: {to?.sheetName} Table{" "}
                                        {to?.extractionId} {">"} {to?.fileName}
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    );
                })}
            </Typography>
        </Modal>
    );
};
